export enum AdminNotificationType {
  courtBookingCreated = 'courtBookingCreated',
  courtBookingCanceled = 'courtBookingCanceled',
  paymentFailed = 'paymentFailed',
}

export interface AdminNotificationFeedItemDto {
  id: string;
  type: AdminNotificationType;
  title: string;
  message: string;
  data?: Record<string, any>;
  isRead: boolean;
  createdAt: string;
}

export interface GetAdminNotificationFeedOutputDto {
  notifications: AdminNotificationFeedItemDto[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
  unreadCount: number;
}

export interface AdminNotificationUnreadCountDto {
  count: number;
}
